import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="discount-operation"
export default class extends Controller {

  static values = {
    remainingDiscountCodes: String,
  }

  connect() {
  }
}
